import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  projectMapsKeys,
  RequestTypes,
} from '@core/react-query/features/projects/maps'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ProjectMapLayer } from '@core/entities/project/ProjectMapLayer'

export const useGetProjectMapLayers = (
  payload: RequestTypes['getProjectMapLayers'],
  options?: UseQueryOptions<ProjectMapLayer[], RequestErrorType>,
) => {
  return useQuery({
    ...projectMapsKeys.getProjectMapLayers(payload),
    ...options,
  })
}
